import { createContext, PropsWithChildren, useContext, useState } from 'react';
import { DealerStyles } from '../hooks/useDealerTheme';

type GeneralContextType = {
  // this is a hack to make dealerStyles available outside K3Main
  dealerStyles: DealerStyles | null;
  setDealerStyles: (styles: DealerStyles) => void;
};

const generalContext = createContext<GeneralContextType>({
  dealerStyles: null,
  setDealerStyles: () => {
    console.error('General Provider missing');
  },
});

export const useGeneralContext = () => useContext(generalContext);

export const GeneralProvider = (props: PropsWithChildren) => {
  const [dealerStyles, setDealerStyles] =
    useState<GeneralContextType['dealerStyles']>(null);

  return (
    <generalContext.Provider value={{ dealerStyles, setDealerStyles }}>
      {props.children}
    </generalContext.Provider>
  );
};
